
/**
 * Valida los datos de un objeto notificación
 * Ejemplo de objeto:
 * {
 *  "id": "1",
 *  "rules": "{"rules":[{"name":"related_purchase_id","operator":"equal","values":[true]}]}",
 *  "description": "Mi descripcion",
 *  "templateId": "4",
 *  "enabled": "1"
 * }
 *
 * @param notification
 * @returns {Array}
 */
const validate = function (notification) {
    let errorMessages = [];

    if (!notification.name) {
        errorMessages.push("Es necesario introducir un nombre.");
    }

    if (!notification.type) {
        errorMessages.push("Es necesario seleccionar un tipo.");
    }

    if (!notification.labelId) {
        errorMessages.push("Es necesario introducir una etiqueta válida.");
    }

    if (!notification.rules) {
        errorMessages.push("Es necesario configurar alguna regla.");
    } else {
        let rulesObj = JSON.parse(notification.rules);
        if (!rulesObj.rules || !rulesObj.rules.length) {
            errorMessages.push("Es necesario configurar alguna regla.");
        }
    }
    return errorMessages;
}

export default {
    validate
};
